import { useEffect } from "react";
import { PURCHASE } from "../../app/routes";

export function useNormalizePaymentReturnUrl() {
  useEffect(() => {
    // Działa tylko w trybie standalone (poza iframe)
    if (typeof window === "undefined") return;
    if (window.self !== window.top) return;

    // Jeśli już jesteśmy na stronie sukcesu, nic nie robimy
    if (window.location.pathname === PURCHASE) return;

    const href = window.location.href;

    let url: URL;
    try {
      url = new URL(href);
    } catch {
      // Jeśli przeglądarka nie potrafi sparsować URL, nie ingerujemy
      return;
    }

    const billKey = url.searchParams.get("k");
    let rawId = url.searchParams.get("id") ?? "";

    // Musimy mieć zarówno id, jak i k – inaczej nie dotykamy URL
    if (!billKey || !rawId) return;

    const hasSuccessInId = rawId.includes("success");
    const hasSuccessInHref = href.includes("success");

    // Reagujemy tylko na powroty z płatności oznaczone "success"
    if (!hasSuccessInId && !hasSuccessInHref) return;

    // Naprawiamy potencjalnie zepsute id, np. "1252?success" -> "1252"
    let cleanId = rawId.split("?")[0];
    cleanId = cleanId.split("&")[0];

    if (!cleanId) return;

    const target = new URL(PURCHASE, window.location.origin);
    target.searchParams.set("id", cleanId);
    target.searchParams.set("k", billKey);

    window.location.replace(target.toString());
  }, []);
}

